export const useCutLengthText = (text, cutLength) => {
    if (text.length < cutLength) {
        return text
    }
    return text.slice(0, cutLength) + '...'
}
